import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { TaskStatusFindInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-find.dto';
import type { TaskStatusFlatListQueryInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-flat-list-query.dto';
import type { TaskStatusPageInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-page.dto';
import type { TaskStatusRegistryQueryInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-registry-query.dto';
import { Observable } from 'rxjs';
import { BaseService } from '@zaoblako/web/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class TaskStatusService extends BaseService {
  protected baseUrl = '/finance/brs/task-status';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: TaskStatusRegistryQueryInterface): Observable<TaskStatusPageInterface> {
    return this.http.get<TaskStatusPageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  }

  public findManyFlat(params?: TaskStatusFlatListQueryInterface): Observable<TaskStatusFindInterface[]> {
    return this.http.get<TaskStatusFindInterface[]>(`${this.baseUrl}/flat`, {
      params: params ? this.objectToHttpParams(params as Record<string, unknown>) : {}
    });
  }

  public override find<T = TaskStatusFindInterface>(query?: TaskStatusFlatListQueryInterface): Observable<T[]> {
    return this.findManyFlat(query) as Observable<T[]>;
  }
}
